import { render, staticRenderFns } from "./TestimonialRating.vue?vue&type=template&id=725563b7&"
import script from "./TestimonialRating.vue?vue&type=script&lang=js&"
export * from "./TestimonialRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports